/**
 * @generated SignedSource<<a73a6689a6d9a0d9957dc75432412365>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CheckoutStickySubmitButton_viewer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutSubmitButton_viewer">;
  readonly " $fragmentType": "CheckoutStickySubmitButton_viewer";
};
export type CheckoutStickySubmitButton_viewer$key = {
  readonly " $data"?: CheckoutStickySubmitButton_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutStickySubmitButton_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CheckoutStickySubmitButton_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CheckoutSubmitButton_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "a69b4ce2274dd0d5cbd03ff4cd72aa1e";

export default node;
